export default {
  apiUri: process.env.FOODIE_API_URI,
};



//////////////////
// WEBPACK FOOTER
// ./config/apolloConfig.js
// module id = null
// module chunks = 